export const CLASS_COLORS: Record<string, string> = {
    person: '#25f370',
    car: '#0088ff',
    truck: '#2aed92',
    bus: '#ff8800',
    motorcycle: '#aa00ff',
    default: '#ffff00'
};

export const colors: Record<string, string> = {
    bus: "#D946EF",
    HGV: "#80b4f5",
    Bicycle: "#c895f8",
    Pedestrian: "#b6e8c8",
    car: "#a8bfe4",
    LCV: "#FEF9C3",
    person: "#97f0cf",
    truck: "#14B8A6",
    motorcycle: "#C084FC",
    pet: "#2563EB",
    ttc: "#F97316",
    auto: "#F97316",
};

// Classes hidden from the dashboard UI. Data is still counted and exported;
// this only controls what the graph, chips and line bars render.
export const HIDDEN_CLASSES = new Set(["person"]);

export const isHiddenClass = (cls: string) =>
    HIDDEN_CLASSES.has(String(cls).toLowerCase());

// Regions that exist specifically to count people. Person stays visible here
// even though it is hidden everywhere else.
export const PERSON_REGIONS = new Set(["ped_cross", "pedcross", "ped_crossing"]);

// Regions that belong under "Lines" but are not named "line*".
export const EXTRA_LINE_REGIONS = new Set(["ped_cross", "pedcross", "ped_crossing"]);

export const isLineRegion = (key: string) => {
    const lower = String(key).toLowerCase();
    return lower.includes("line") || EXTRA_LINE_REGIONS.has(lower);
};

export const stripHiddenClasses = (
    obj: Record<string, any> | null | undefined,
    region?: string
) =>
    region && PERSON_REGIONS.has(String(region).toLowerCase())
        ? { ...(obj || {}) }
        : Object.fromEntries(
              Object.entries(obj || {}).filter(([key]) => !isHiddenClass(key))
          );
